<template>
  <div class="select-dropdown">
    <div class="select-dropdown__trigger-wrap">
      <button type="button" class="select-dropdown__trigger"
              @click.prevent="isOpen = true">
        <span>{{ name }}</span>
        <BaseSvg v-if="true"
                 class="select-dropdown__trigger-arrow"
                 name="ico-arrow"/>
      </button>
      <div v-if="selectedFirst"
           @click.prevent="onClear(filterKey)"
           class="select-dropdown__selected">
        <span class="select-dropdown__selected-text">
          {{ selectedFirst.name }}
          <template v-if="selectedProperties.length > 1">
            {{ $tAccount('and more') }} {{ selectedProperties.length - 1 }}
          </template>
        </span>
        <span  class="select-dropdown__selected-del">
          <BaseSvg name="ico-close"/>
        </span>
      </div>
    </div>
    <transition name="dropdown">
      <div
          v-if="isOpen"
          v-click-out="() => this.isOpen = false"
          class="select-dropdown__dropdown"
      >
        <button
            type="button"
            class="select-dropdown__close"
            @click.prevent="isOpen = false"
        >
          <BaseSvg
              name="ico-close"
              width=".8rem"
              height=".8rem"
          />
        </button>

        <div :class="short ? '_short' : null"
             class="select-dropdown__options  filter-checkbox">
          <slot>
            <ul class="filter-checkbox__list">
              <li v-for="item in values"
                  :key="item.id">
                <BaseCheckbox :label="item.name"
                              :checked="isChecked([filterKey, item.id])"
                              @input="onToggleFilter([filterKey, item.id])"/>
              </li>
            </ul>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'AccountTabItemSelectDropdown',
    props: {
      name: String,
      filterKey: String,
      values: Array,
      selectedProperties: Array,
      isChecked: Function,
      onToggleFilter: Function,
      onClear: Function,
      short: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      selectedFirst() {
        if (!this.selectedProperties || !this.selectedProperties.length) return

        return this.values.find(item => {
          return Number(item.id) === Number(this.selectedProperties[0])
        })
      }
    },
    methods: {

    }
  }
</script>

<style lang="less">

</style>